import {updateAllFiles, updateSelectedOrNewMovement} from "./myMovementsSlice";
export function setAllMovementData(dispatch, payload) {
    console.log('in helpers', payload)
    // step 1 data
    const { file, img2, img1, training_voice, important_points_voice } = payload;
    console.log(file, img2, img1, training_voice, important_points_voice)
    dispatch(updateAllFiles({file, img2, img1, training_voice, important_points_voice}));
    dispatch(updateSelectedOrNewMovement({type: 'all', value: payload}))
}